import { useRef, useState, useEffect, useContext, useCallback, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import axios from "axios";

import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { BarrioContext } from "../components/BarrioContext";
import { useAuth } from "../components/AuthContext";
import { useTerminologia } from "../hooks/useTerminologia";

import LoadingOverlay from '../components/LoadingOverlay';
import { Toast } from 'primereact/toast';

const SentenciaJudicialUnidadFuncional = () => {
    const toast = useRef(null);
    const HOST_API = process.env.REACT_APP_URL;
    const { barrio } = useContext(BarrioContext);
    const { administracionId } = useAuth();
    const t = useTerminologia();
    const [loadingBackdrop, setLoadingBackdrop] = useState(false);
    const [unidadesFuncionales, setUnidadesFuncionales] = useState([]);

    useEffect(() => {
        if (!barrio?.id) return;
        axios.get(`${HOST_API}api/unidadesFuncionales/getUnidadesFuncionales?unidadFuncionalId=0&administracionId=${administracionId}&barrioId=${barrio.id}`)
            .then(res => setUnidadesFuncionales(res.data))
            .catch(err => console.error('Error cargando unidades funcionales:', err));
    }, [barrio?.id, administracionId]);

    const location = useLocation();
    const [selectedDate, setSelectedDate] = useState(location.state?.selectedDate ?? new Date());

    // â”€â”€â”€ Helpers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const formatDate = (date) => {
        if (!date) return "";
        const year  = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day   = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    const camelToHeader = (key) =>
        key.replace(/([A-Z])/g, " $1").replace(/^./, (s) => s.toUpperCase()).trim();

    const formatValue = (value, type) => {
        if (value === null || value === undefined) return "";
        switch (type) {
            case "date":
                return new Date(value).toLocaleDateString("es-AR");
            case "currency":
                return typeof value === "number"
                    ? value.toLocaleString("es-AR", { style: "currency", currency: "ARS" })
                    : value;
            default:
                return typeof value === "object" ? JSON.stringify(value) : value;
        }
    };

    const flattenRow = (row) => {
        const flat = {};
        for (const [key, value] of Object.entries(row)) {
            if (typeof value === "object" && value !== null && !key.endsWith("_type")) {
                for (const [nestedKey, nestedValue] of Object.entries(value)) {
                    flat[nestedKey] = nestedValue;
                    flat[`${nestedKey}_type`] = row[`${key}_type`] ?? "currency";
                }
            } else {
                flat[key] = value;
            }
        }
        return flat;
    };

    // â”€â”€â”€ Estado â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const initialFormData = {
        sentenciaId: 0,
        unidadFuncionalId: "",
        porcentajeDescuento: "",
        fechaInicio: null,
        fechaFin: null,
        observaciones: "",
    };

    const [formData, setFormData] = useState(initialFormData);
    const [visible, setVisible] = useState(false);
    const [sentencias, setSentencias] = useState([]);

    const handleChange = (campo, valor) => {
        setFormData((prev) => ({ ...prev, [campo]: valor }));
    };

    // â”€â”€â”€ Submit â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const handleSubmit = async (e) => {
        e.preventDefault();
        const user = JSON.parse(localStorage.getItem("user"));
        const payload = {
            ...formData,
            barrioId: barrio.id,
            administracionId,
            usuarioId: user?.id,
        };
        try {
            await axios.post(`${HOST_API}api/sentenciasJudicialesUF/SaveSentencia`, payload);
            setVisible(false);
            fetchSentencias();
        } catch (err) {
            console.error(err);
        }
    };

    // â”€â”€â”€ Fetch â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const fetchSentencias = useCallback(async () => {
        if (!barrio?.id) return;
        setLoadingBackdrop(true);
        try {
            const fecha = formatDate(selectedDate);
            const response = await axios.get(
                `${HOST_API}api/sentenciasJudicialesUF/GetSentencias?barrioId=${barrio.id}&periodo=${fecha}&administracionId=${administracionId}`
            );
            console.log(response.data);
            setSentencias(response.data);
        } catch (err) {
            console.error(err.message || "Error al obtener sentencias");
        } finally {
            setLoadingBackdrop(false);
        }
    }, [barrio?.id, selectedDate, administracionId]);

    useEffect(() => {
        fetchSentencias();
    }, [fetchSentencias]);

    const sentenciasFlat = useMemo(() => sentencias?.map(flattenRow) ?? [], [sentencias]);

    const columns = useMemo(() => {
        if (!sentenciasFlat?.length) return [];
        const firstRow = sentenciasFlat[0];
        return Object.keys(firstRow)
            .filter((key) => !key.endsWith("_type") && !['usuario', 'nombreUsuario', 'fechaAlta', 'razonSocial', 'nombreBarrio', 'barrio', 'barrioNombre'].includes(key))
            .map((field) => ({
                field,
                type: firstRow[`${field}_type`] ?? "text",
                header: camelToHeader(field),
            }));
    }, [sentencias]);

    // â”€â”€â”€ Edit / Delete â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const handleEdit = (row) => {
        setFormData({
            ...initialFormData,
            ...row,
            fechaInicio: row.fechaInicio ? new Date(row.fechaInicio) : null,
            fechaFin: row.fechaFin ? new Date(row.fechaFin) : null,
            unidadFuncionalId: Number(row.unidadFuncionalId) || null,
        });
        setVisible(true);
    };

    const handleDelete = (id) => {
        confirmDialog({
            message: '¿Estás seguro de eliminar esta sentencia?',
            header: 'Confirmar eliminación',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Eliminar',
            rejectLabel: 'Cancelar',
            acceptClassName: 'p-button-danger',
            accept: async () => {
                try {
                    await axios.delete(`${HOST_API}api/sentenciasJudicialesUF/DeleteSentencia/${id}`);
                    fetchSentencias();
                } catch (err) {
                    console.error(err);
                }
            },
        });
    };

    // â”€â”€â”€ Render â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    return (
        <>
            <h4>Sentencia Judicial {t.UnidadFuncional}</h4>
            <br />

            <ConfirmDialog />
            <Toast ref={toast} />
            <LoadingOverlay visible={loadingBackdrop} />

            <div className="flex align-items-center gap-3 mb-3">
                <Button
                    label="Nueva Sentencia"
                    icon="pi pi-plus"
                    onClick={() => { setFormData(initialFormData); setVisible(true); }}
                />
                <Calendar
                    value={selectedDate}
                    view="month"
                    dateFormat="mm/yy"
                    onChange={(e) => setSelectedDate(e.value)}
                    showIcon
                    className="p-inputtext-sm"
                />
            </div>

            <Dialog
                header={`Sentencia Judicial ${t.UnidadFuncional}`}
                visible={visible}
                style={{ width: "60vw" }}
                breakpoints={{ "960px": "100vw" }}
                modal
                onHide={() => setVisible(false)}
            >
                <form className="p-fluid grid" onSubmit={handleSubmit}>
                    <div className="col-12">
                        <div className="col-12 flex flex-wrap gap-3 mt-3">

                            <div className="w-full md:w-4">
                                <label>{t.UnidadFuncional}</label>
                                <Dropdown
                                    value={formData.unidadFuncionalId || null}
                                    options={unidadesFuncionales}
                                    optionLabel="unidadFuncional"
                                    optionValue="unidadFuncionalId"
                                    onChange={(e) => handleChange("unidadFuncionalId", e.value)}
                                    placeholder={`Seleccionar ${t.UF}`}
                                    className="p-inputtext-sm w-full"
                                    filter
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Porcentaje Descuento</label>
                                <InputText
                                    type="number"
                                    step="0.01"
                                    value={formData.porcentajeDescuento || ""}
                                    onChange={(e) => handleChange("porcentajeDescuento", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Fecha inicio</label>
                                <Calendar
                                    value={formData.fechaInicio}
                                    dateFormat="dd/mm/yy"
                                    onChange={(e) => handleChange("fechaInicio", e.value)}
                                    showIcon
                                    className="p-inputtext-sm"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Fecha fin</label>
                                <Calendar
                                    value={formData.fechaFin}
                                    dateFormat="dd/mm/yy"
                                    onChange={(e) => handleChange("fechaFin", e.value)}
                                    showIcon
                                    className="p-inputtext-sm"
                                />
                            </div>

                            <div className="w-full">
                                <label>Observaciones</label>
                                <InputText
                                    type="text"
                                    value={formData.observaciones || ""}
                                    onChange={(e) => handleChange("observaciones", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="col-12 mt-3">
                                <Button label="Guardar" icon="pi pi-save" type="submit" />
                            </div>

                        </div>
                    </div>
                </form>
            </Dialog>

            <div className="grid">
                <div className="col-12">
                    <DataTable
                        value={sentenciasFlat}
                        paginator
                        rows={10}
                        showGridlines
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        responsiveLayout="scroll"
                        emptyMessage="No hay sentencias cargadas"
                        className="p-datatable-gridlines bg-white"
                    >
                        {columns.map(({ field, header, type }) => (
                            <Column
                                key={field}
                                field={field}
                                header={header}
                                sortable
                                body={(row) => formatValue(row[field], type)}
                            />
                        ))}
                        <Column
                            header="Acciones"
                            style={{ width: '8rem' }}
                            body={(row) => (
                                <div className="flex gap-2 justify-content-center">
                                    <Button icon="pi pi-pencil" rounded text severity="warning" onClick={() => handleEdit(row)} tooltip="Editar" />
                                    <Button icon="pi pi-trash" rounded className="btn-delete" onClick={() => handleDelete(row.sentenciaId)} tooltip="Eliminar" />
                                </div>
                            )}
                        />
                    </DataTable>
                </div>
            </div>
        </>
    );
};

export default SentenciaJudicialUnidadFuncional;
